import axios from 'axios';

export async function getCurrency(host: string) {
  const response = await axios.get(`https://${host}/currency-menus`);
  return response.data;
}
